import { useSelector } from 'react-redux'

import {
  selectAccount,
  selectAdmins,
  selectInternalAccounts,
  selectRoles
} from 'redux/selectors/Accounts'
import { ApplicationState } from 'redux/Stores/types'

/**
 * Hook for all accounts
 * @returns AccountsSelectorType
 */
export const useAccounts = (includeCompanyGroupUsers = false) => {
  return useSelector((state: ApplicationState) =>
    selectInternalAccounts(state, includeCompanyGroupUsers)
  )
}

/**
 * Hook for all accounts
 * @returns [accounts, loading]
 */
export const useAccount = (id: string | null) => {
  return useSelector((state: ApplicationState) => selectAccount(state, id))
}

/**
 * Hook for all accounts
 * @returns AccountsSelectorType
 */
export const useAdmins = () => {
  return useSelector(selectAdmins)
}

export const useRoles = () => {
  return useSelector(selectRoles)
}
